import useOnScreen from "../../components/UseOnScreen/UseOnScreen"; 
import TypingEffect from "../../components/Animation/TypingEffect";
import "../About/About.css";

const About = () => {
    const [aboutRef, isVisible] = useOnScreen({ threshold: 0.5, once: true });
    const textSobre = "Sobre";
    const textMim = "mim";

    return (
        <div id="about" className="" ref={aboutRef}>
            <div className="img-container">
                <div className="about-text">
                    {isVisible ? (
                        <>
                            <TypingEffect
                                text={textSobre}
                                speed={300} 
                                id="title-first-part"   
                                className="title"
                                />
                            <br />
                            <TypingEffect
                                text={textMim}
                                speed={300}
                                id="title-second-part"
                                className="title"
                            />
                        </>
                    ) : (
                        <div className="placeholder-text" style={{ visibility: 'hidden' }}>
                            <span id="title-first-part" className="title">{textSobre}</span><br />
                            <span id="title-second-part" className="title">{textMim}</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default About;